
import {switchMap, tap} from 'rxjs/operators';
import { AfterViewChecked, AfterViewInit, ChangeDetectorRef,
    Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DepotRequeteState } from '../../depot-requete-state.model';
import { NgForm } from '@angular/forms';
import { ScrollToService } from '../../../shared';
import { ErrorService } from '../../../shared/services/error.service';
import { DraftDepotRequeteService } from '../../draft-depot-requete.service';
import { Observable, Subscription, of } from 'rxjs';
import { PieceComplementaireOrigineType } from '../../../entities/piece-jointe';
import { ParametersService } from '../../../shared/services/parameters.service';
import { ContentieuxSocial } from '../../../entities/contentieux-social';
import { DraftRequete } from '../../../entities/draft-requete/draft-requete.model';

@Component({
    templateUrl: './requete.component.html',
    styleUrls: ['./requete.component.scss']
})
export class RequeteComponent implements AfterViewChecked, OnInit, AfterViewInit, OnDestroy {
    depotRequeteState: DepotRequeteState;

    showErrorMessageUrgenceRequete = false;

    private parameterSubscription: Subscription;
    private scrollTarget: string;
    private scrollToError = false;
    public juridictionAutoSaveSuccess = false;
    public autoSaveError = false;
    public saveDraftSuccess = false;
    public saveDraftError = false;
    private autoSaveTime: any;
    maxFileSize: number;

    public urgenceRequeteChampsObligatoireFilled = {
        concernContentieuxSocial: true
    }

    public sociauxDALOChampsObligatoiresFilled = {
        hasDocument: true,
        raisonSansDocument: true,
        nomsAdministrations: true,
        objetDemande: true,
        motifs: true,
        conclusionDALO: true
    }

    public litigeLieDecisionChampsObligatoiresFilled = {
        souhait: true,
        hasDocument: true,
        raisonSansDocument: true,
        nomsAdministrations: true,
        objetDemande: true,
        contexteInterventionDecision: true,
        raisonContestations: true,
        raisonContestationDetail: true,
        pieceMalInterpreteLibelle: true,
        pieceMalApprecieLibelle: true,
        conclusionLitigeAdminCheckbox: true
    }

    public reclamerUneSommeChampsObligatoiresFilled = {
        typeLitige: true,
        nomsAdministrations: true,
        objetDemande: true,
        contexteInterventionDecision: true,
        pourquoiSommeDue: true,
        pieceSommeDue: true,
        montantDuMontant: true,
        pieceMontantDu: true,
        conclusionReclamerSommeCondamnerAdmin: true
    }

    public contesterUneSommeChampsObligatoiresFilled = {
        nomsAdministrations: true,
        objetDemande: true,
        faitConduitAuLitige: true,
        typeActe: true,
        raisonAvisDimpositionIrreguliers: true,
        conclusionAvisImpositionImpot: true,
        raisonPasPayerImpot: true,
        pieceAvisImpositionInfondeeEtAutreLibelle: true,
        raisonInvalidationTitres: true,
        raisonInvalidationTitreDetail: true,
        conclusionContesterSommeTitreEmisIrregulierDes: true,
        conclusionContesterSommeTitreEmisIrregulierMontant: true
    }

    public indemnisationChampsObligatoiresFilled = {
        nomsAdministrations: true,
        objetDemande: true,
        faitConduitSituationReparation: true,
        prejudiceEvaluableEnArgents: true,
        precisionPrejudice: true,
        piecePrecisionPrejudiceLibelle: true,
        originePrejudice: true,
        conclusionIndemnisationCondamnerAdmin: true,
        conclusionIndemnisationMontant: true
    }

    public requeteRedigeePieceComplementaireLebelleFilled = {
        requeteRedigeePCLibelle: true
    }

    @Output() previousStep: EventEmitter<any> = new EventEmitter();
    @Output() nextStep: EventEmitter<any> = new EventEmitter();
    @Output() hideAlertDraft: EventEmitter<any> = new EventEmitter();
    @Output() showErrorAlertDraft: EventEmitter<any> = new EventEmitter();
    @Output() showSuccessAlertDraft: EventEmitter<any> = new EventEmitter();
    @Output() showAutoSaveSuccessAlertDraft: EventEmitter<any> = new EventEmitter();

    @ViewChild(NgForm) form: NgForm;

    constructor(
        private scrollToService: ScrollToService,
        private errorService: ErrorService,
        private draftDepotRequeteService: DraftDepotRequeteService,
        private parametersService: ParametersService,
        private changeDetectorRef: ChangeDetectorRef
    ) {
        this.depotRequeteState = this.draftDepotRequeteService.depotRequeteState;
        if (this.depotRequeteState.isStepJuridictionAutoSaveSucceed && !this.depotRequeteState.isStepRequeteAutoSaveSucceed) {
            this.juridictionAutoSaveSuccess = true;
            this.autoSaveTime = this.draftDepotRequeteService.getAutoSaveTime();
            this.draftDepotRequeteService.sendData(this.autoSaveTime);
        }
        this.parameterSubscription = this.parametersService.getParameters().subscribe(parameters => {
            this.maxFileSize = parameters.maxFileSize;
        });
    }

    ngOnInit(): void {
        this.hideAlertDraft.emit();
        if (this.juridictionAutoSaveSuccess) {
            this.showAutoSaveSuccessAlertDraft.emit();
        }
    }

    ngAfterViewInit() {
        this.draftDepotRequeteService.refreshRequete().pipe(
            tap(draftRequete => this.updateDepotRequeteState(draftRequete)),
            switchMap(draftRequete => draftRequete.contentieuxSocialId ?
                this.draftDepotRequeteService.getContentieuxSocial(draftRequete.contentieuxSocialId) :
                of(new ContentieuxSocial())),
                tap(cs => this.depotRequeteState.requeteCS = cs)
        ).subscribe();
        document.getElementById('logo-link').focus();
    }

    private updateDepotRequeteState(draftRequete: DraftRequete): void {
        if (draftRequete.typeRequeteId == null) {
            this.depotRequeteState.urgenceRequete = undefined!;
        } else {
            this.depotRequeteState.urgenceRequete = this.depotRequeteState.typeJuridiction.urgencesRequete.find(urgenceRequete =>
                urgenceRequete.id === draftRequete.typeRequeteId)!;
        }
        this.depotRequeteState.concernContentieuxSocial = draftRequete.concernContentieuxSocial;
        this.depotRequeteState.formActivated = draftRequete.formActivated;
        this.draftDepotRequeteService.refreshPiecesFromDraft(draftRequete, this.depotRequeteState);
    }

    ngAfterViewChecked(): void {
        if (this.scrollTarget) {
            this.scrollToService.scrollBySelector(this.scrollTarget);
            this.scrollTarget = null;
        }
        if (this.scrollToError) {
            this.scrollToService.scrollToFirstErrorForStepRequeteInDepotRequete();
            /* this.scrollToService.scrollToFirstError(); */
            this.scrollToError = false;
        }
        // TODO: TRC-890 put it to where changes happened
        this.changeDetectorRef.detectChanges();
    }

    ngOnDestroy() {
        this.parameterSubscription.unsubscribe();
    }

    next(): Observable<void> {
        if (this.depotRequeteState.urgenceRequete == null) {
            this.showErrorMessageUrgenceRequete = true;
        }
        this.hideAlertDraft.emit();
        if (this.depotRequeteState.urgenceRequete && this.depotRequeteState.urgenceRequete.codeUrgence === 0) {
            return this.nextStepWithNormalProceeding();
        } else {
            return this.nextStepWithInterimProceeding();
        }
    }

    private nextStepWithNormalProceeding(): Observable<void> {
        if (this.form.valid && this.checkIfUrgenceRequeteFilled() && this.checkIfCSFormFilled()) {
            return this.saveRequete().pipe(tap(
                () => {
                    this.depotRequeteState.isStepRequeteAutoSaveSucceed = true;
                    this.draftDepotRequeteService.depotRequeteState.isStepRequeteAutoSaveSucceed = true;
                    this.nextStep.emit()
                },
                error => {
                    this.autoSaveError = true;
                    this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, this.showErrorAlertDraft);
                }
            ));
        } else {
            this.updateUrgenceRequeteChampsObligatoiresFilled();
            if (this.depotRequeteState.formActivated) {
                if (this.depotRequeteState.concernContentieuxSocial) {
                    this.updateSociauxDALOChampsObligatoireFilledObj();
                } else {
                    if (this.depotRequeteState.requeteCS.souhait == null ||
                        this.depotRequeteState.requeteCS.souhait ===
                        'Remplir le formulaire : litige lié à une décision de l\'administration') {
                            this.updateLitigeLieDecisionChampsObligatoireFilledObj();
                    } else if (this.depotRequeteState.requeteCS.souhait ===
                        'Remplir le formulaire : litige lié à une somme d\'argent') {
                            if (this.depotRequeteState.requeteCS.typeLitige == null || this.depotRequeteState.requeteCS.typeLitige ===
                                'Vous réclamez une somme d\'argent à l\'administration') {
                                    this.updateReclamerUneSommeChampsObligatoireFilledObj();
                            } else if (this.depotRequeteState.requeteCS.typeLitige ===
                                'Vous contestez une somme d\'argent réclamée par l\'administration') {
                                    this.updateContesterUneSommeChampsObligatoireFilledObj();
                            } else {
                                this.updateIndemnisationChampsObligatoireFilledObj();
                            }
                    } else {
                        this.updateRequeteRedigeePCFilledObj();
                    }
                }
            } else {
                if (this.depotRequeteState.concernContentieuxSocial) {
                    this.updateSociauxDALOChampsObligatoireFilledObj();
                }
            }
            this.errorService.markAllControlsAsTouched(this.form);
            this.scrollToError = true;
        }
    }

    private nextStepWithInterimProceeding(): Observable<void> {
        if (this.form.valid) {
            return this.saveRequete().pipe(tap(
                () => {
                    this.depotRequeteState.isStepRequeteAutoSaveSucceed = true;
                    this.draftDepotRequeteService.depotRequeteState.isStepRequeteAutoSaveSucceed = true;
                    this.nextStep.emit()
                },
                error => {
                    this.autoSaveError = true;
                    this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, this.showErrorAlertDraft);
                }
            ));

        } else {
            this.errorService.markAllControlsAsTouched(this.form);
            this.scrollToError = true;
        }
    }
    previous(): void {
        this.depotRequeteState.isStepRequeteAutoSaveSucceed = false;
        this.previousStep.emit();
    }

    saveDraft(): Observable<any> {
        this.hideAlertDraft.emit();

        return this.saveRequete().pipe(tap(
            () => {
                this.saveDraftSuccess = true;
                this.juridictionAutoSaveSuccess = false;
                this.showSuccessAlertDraft.emit();
            },
            (error) => {
                this.saveDraftError = true;
                this.juridictionAutoSaveSuccess = false;
                this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, this.showErrorAlertDraft);
            }
        ));
    }

    saveDraftAgain(): any {
        this.saveRequete().subscribe(
            () => {
                this.saveDraftSuccess = true;
                this.juridictionAutoSaveSuccess = false;
                this.showSuccessAlertDraft.emit();
            },
            (error) => {
                this.saveDraftError = true;
                this.juridictionAutoSaveSuccess = false;
                this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, this.showErrorAlertDraft);
            }
        );
    }

    updateState(concerneCSDALO: any) {
        console.log('updateState concerneCSDALO ', concerneCSDALO);
        this.depotRequeteState = {... this.depotRequeteState, concernContentieuxSocial: concerneCSDALO};
        console.log('updateState state concern cs dalo ', this.depotRequeteState.concernContentieuxSocial);
        this.draftDepotRequeteService.depotRequeteState = this.depotRequeteState;
    }

    updateURState(urgenceRequete: any) {
        console.log('updateURState urgenceRequete ', urgenceRequete);
        this.depotRequeteState = {... this.depotRequeteState, urgenceRequete: urgenceRequete};
        console.log('updateState state concern u r ', this.depotRequeteState.urgenceRequete);
        this.draftDepotRequeteService.depotRequeteState = this.depotRequeteState;
    }

    close() {
        this.autoSaveError = false;
    }

    saveRequete(): Observable<any> {
        return this.draftDepotRequeteService.saveRequeteByEmergencyType(this.depotRequeteState.urgenceRequete);
    }

    displayContentieuxSocialSection(): boolean {
        return this.depotRequeteState.concernContentieuxSocial;
    }

    checkIfUrgenceRequeteFilled() {
        this.updateUrgenceRequeteChampsObligatoiresFilled();
        return this.depotRequeteState.urgenceRequete && (typeof this.depotRequeteState.urgenceRequete !== 'boolean') &&
        this.checkRadioConcernCSChecked();
    }

    updateUrgenceRequeteChampsObligatoiresFilled(): void {
        if (this.depotRequeteState.typeJuridiction.code !== 'CE') {
            if (this.depotRequeteState.concernContentieuxSocial == null) {
                this.urgenceRequeteChampsObligatoireFilled.concernContentieuxSocial = false;
            }
        }
    }

    checkRadioConcernCSChecked(): boolean {
        let radioChecked = true;
        if (this.depotRequeteState.typeJuridiction.code !== 'CE') {
            if (this.depotRequeteState.concernContentieuxSocial == null) {
                radioChecked = false;
            } else {
                radioChecked = true;
            }
        }
        return radioChecked;
    }

    checkIfCSFormFilled(): boolean {
        if (this.depotRequeteState.formActivated) {
            if (this.depotRequeteState.concernContentieuxSocial && this.depotRequeteState.requeteCS) {
                return this.checkConcernContentieuxSocial();
            } else if (!this.depotRequeteState.concernContentieuxSocial && this.depotRequeteState.requeteCS) {
                return  !!(this.depotRequeteState.requeteCS.souhait) && this.checkNotConcernContentieuxSocial();
            } else {
                return true;
            }
        } else {
            if (this.depotRequeteState.concernContentieuxSocial && this.depotRequeteState.requeteCS) {
                return this.checkConcernContentieuxSocial();
            } else {
                return true;
            }
        }
    }

    checkConcernContentieuxSocial(): boolean {
        // piece complémentaire rapo obligatoire
        let rapo = this.depotRequeteState.piecesComplementaires.some(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.RAPO);
        let acteAttaquee = this.depotRequeteState.acteAttaquesAFusioner[0];
        this.updateSociauxDALOChampsObligatoireFilledObj();
        if (this.depotRequeteState.requeteCS.hasDocument == null) {
            return false;
        } else if (this.depotRequeteState.requeteCS.hasDocument) {
          return rapo && !!acteAttaquee && !!(this.depotRequeteState.requeteCS.nomsAdministrations) &&
          !!(this.depotRequeteState.requeteCS.objetDemande) &&
          !!(this.depotRequeteState.requeteCS.motifs) &&
          !!(this.depotRequeteState.requeteCS.conclusionDALO)
        } else {
          return rapo && !!(this.depotRequeteState.requeteCS.raisonSansDocument) &&
          !!(this.depotRequeteState.requeteCS.nomsAdministrations) &&
          !!(this.depotRequeteState.requeteCS.objetDemande) &&
          !!(this.depotRequeteState.requeteCS.motifs) &&
          !!(this.depotRequeteState.requeteCS.conclusionDALO)
        }
    }

    updateSociauxDALOChampsObligatoireFilledObj(): void {
        if (this.depotRequeteState.requeteCS.hasDocument == null) {
            this.sociauxDALOChampsObligatoiresFilled.hasDocument = false;
        }
        if (this.depotRequeteState.requeteCS.hasDocument === false &&
            this.depotRequeteState.requeteCS.raisonSansDocument == null) {
                this.sociauxDALOChampsObligatoiresFilled.raisonSansDocument = false;
        }
        if (this.depotRequeteState.requeteCS.nomsAdministrations == null) {
            this.sociauxDALOChampsObligatoiresFilled.nomsAdministrations = false;
        }
        if (this.depotRequeteState.requeteCS.objetDemande == null) {
            this.sociauxDALOChampsObligatoiresFilled.objetDemande = false;
        }
        if (this.depotRequeteState.requeteCS.motifs == null) {
            this.sociauxDALOChampsObligatoiresFilled.motifs = false;
        }
        if (this.depotRequeteState.requeteCS.conclusionDALO == null) {
            this.sociauxDALOChampsObligatoiresFilled.conclusionDALO = false;
        }
    }

    checkNotConcernContentieuxSocial(): boolean {
        if (this.depotRequeteState.requeteCS.souhait == null) {
            this.litigeLieDecisionChampsObligatoiresFilled.souhait = false;
            return false;
        } else if (this.depotRequeteState.requeteCS.souhait === 'Remplir le formulaire : litige lié à une décision de l\'administration') {
            // souhait choix 1
            let acteAttaquee = this.depotRequeteState.acteAttaquesAFusioner[0];
            this.updateLitigeLieDecisionChampsObligatoireFilledObj();
            if (this.depotRequeteState.requeteCS.hasDocument == null) {
                return false;
            }else if (this.depotRequeteState.requeteCS.hasDocument) {
                return !!acteAttaquee && !!(this.depotRequeteState.requeteCS.nomsAdministrations) &&
                !!(this.depotRequeteState.requeteCS.objetDemande) &&
                !!(this.depotRequeteState.requeteCS.contexteInterventionDecision) &&
                this.checkRaisonContestation() && this.checkRaisonContestationPieceComplementaire() &&
                this.depotRequeteState.requeteCS.conclusionLitigeAdminCheckbox;
            } else {
                return !!acteAttaquee && !!(this.depotRequeteState.requeteCS.raisonSansDocument) &&
                !!(this.depotRequeteState.requeteCS.nomsAdministrations) &&
                !!(this.depotRequeteState.requeteCS.objetDemande) &&
                !!(this.depotRequeteState.requeteCS.contexteInterventionDecision) &&
                this.checkRaisonContestation() && this.checkRaisonContestationPieceComplementaire() &&
                this.depotRequeteState.requeteCS.conclusionLitigeAdminCheckbox;
            }
        } else if (this.depotRequeteState.requeteCS.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent') {
            if (!!this.depotRequeteState.requeteCS.typeLitige) {
                if (this.depotRequeteState.requeteCS.typeLitige === 'Vous réclamez une somme d\'argent à l\'administration') {
                    return this.checkReclamerUneSomme();
                } else if (this.depotRequeteState.requeteCS.typeLitige ===
                    'Vous contestez une somme d\'argent réclamée par l\'administration') {
                        return this.checkContesterUneSomme();
                } else {
                    return this.checkReclamerUneIndemnisation();
                }
            } else {
                this.updateReclamerUneSommeChampsObligatoireFilledObj();
                return false;
            }
        } else {
            let acteAttaquee = this.depotRequeteState.acteAttaquesAFusioner[0];
            this.updateRequeteRedigeePCFilledObj();
            return !!acteAttaquee && !!this.depotRequeteState.requete && this.allPiecesComplementairesHaveLibelle();
        }
    }

    allPiecesComplementairesHaveLibelle(): boolean {
        let libelleFilled = true;
        if (this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.REQUETE_REDIGEE_JUSTIFICATIF).length > 0) {
                this.depotRequeteState.piecesComplementaires.filter(pc =>
                    pc.complementaryFileOriginType === PieceComplementaireOrigineType.REQUETE_REDIGEE_JUSTIFICATIF).forEach(p => {
                        if (!p.libelle || p.libelle.trim() === '') {
                            libelleFilled = false;
                        }
                    })
        }
        return libelleFilled;
    }

    updateLitigeLieDecisionChampsObligatoireFilledObj(): void {
        if (this.depotRequeteState.requeteCS.souhait == null) {
            this.litigeLieDecisionChampsObligatoiresFilled.souhait = false;
            return;
        }
        if (this.depotRequeteState.requeteCS.hasDocument == null) {
            this.litigeLieDecisionChampsObligatoiresFilled.hasDocument = false;
        }
        if (this.depotRequeteState.requeteCS.hasDocument === false &&
            this.depotRequeteState.requeteCS.raisonSansDocument == null) {
                this.litigeLieDecisionChampsObligatoiresFilled.raisonSansDocument = false;
        }
        if (this.depotRequeteState.requeteCS.nomsAdministrations == null) {
            this.litigeLieDecisionChampsObligatoiresFilled.nomsAdministrations = false;
        }
        if (this.depotRequeteState.requeteCS.objetDemande == null) {
            this.litigeLieDecisionChampsObligatoiresFilled.objetDemande = false;
        }
        if (this.depotRequeteState.requeteCS.contexteInterventionDecision == null) {
            this.litigeLieDecisionChampsObligatoiresFilled.contexteInterventionDecision = false;
        }
        if (this.depotRequeteState.requeteCS.raisonContestations == null ||
            this.depotRequeteState.requeteCS.raisonContestations === undefined ||
            this.depotRequeteState.requeteCS.raisonContestations.length === 0) {
            this.litigeLieDecisionChampsObligatoiresFilled.raisonContestations = false;
        }
        if (this.depotRequeteState.requeteCS.raisonContestations != null &&
            this.depotRequeteState.requeteCS.raisonContestations.length > 0 &&
            this.depotRequeteState.requeteCS.raisonContestations.some(rc => !rc.detail)) {
            this.litigeLieDecisionChampsObligatoiresFilled.raisonContestationDetail = false;
        }
        if (this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.MAL_INTERPRETE).length > 0) {
                this.depotRequeteState.piecesComplementaires.filter(pc =>
                    pc.complementaryFileOriginType === PieceComplementaireOrigineType.MAL_INTERPRETE).forEach(mi => {
                        if (!mi.libelle || mi.libelle.trim() === '') {
                            this.litigeLieDecisionChampsObligatoiresFilled.pieceMalInterpreteLibelle = false;
                        }
                    })
        }
        if (this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.MAL_APPRECIE).length > 0) {
                this.depotRequeteState.piecesComplementaires.filter(pc =>
                    pc.complementaryFileOriginType === PieceComplementaireOrigineType.MAL_APPRECIE).forEach(ma => {
                        if (!ma.libelle || ma.libelle.trim() === '') {
                            this.litigeLieDecisionChampsObligatoiresFilled.pieceMalApprecieLibelle = false;
                        }
                    })
        }
        if (this.depotRequeteState.requeteCS.conclusionLitigeAdminCheckbox == null) {
            this.litigeLieDecisionChampsObligatoiresFilled.conclusionLitigeAdminCheckbox = false;
        }
    }

    checkRaisonContestation(): boolean {
        // au moins un choix doit être coché
        // une fois coché, le détail doit être rempli
        let raisonContestationValid = true;
        if (!this.depotRequeteState.requeteCS.raisonContestations) {
            raisonContestationValid = false;
        } else {
            if (this.depotRequeteState.requeteCS.raisonContestations.length <= 0) {
                raisonContestationValid = false;
            } else {
                this.depotRequeteState.requeteCS.raisonContestations.forEach(rc => {
                    if (!rc.detail) {
                        raisonContestationValid = false;
                    }
                });

            }
        }
        return raisonContestationValid;
    }

    checkRaisonContestationPieceComplementaire(): boolean {
        let pieceComplementaireValid = true;
        const pieceMalInterpreter = this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.MAL_INTERPRETE);
            pieceMalInterpreter.forEach(pmi => {
            if (!pmi.libelle || pmi.libelle.trim() === '') {
                pieceComplementaireValid = false;
            }
        });

        const pieceMalAppreciee = this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.MAL_APPRECIE);
            pieceMalAppreciee.forEach(pma => {
            if (!pma.libelle || pma.libelle.trim() === '') {
                pieceComplementaireValid = false;
            }
        })

        return pieceComplementaireValid;

    }

    checkReclamerUneSomme(): boolean {
        this.updateReclamerUneSommeChampsObligatoireFilledObj();
        return this.checkReclamerUneSommePieceComplementaire() &&
        this.depotRequeteState.reclamationPrealablesAFusioner.length > 0 &&
        !!this.depotRequeteState.requeteCS.nomsAdministrations &&
        !!this.depotRequeteState.requeteCS.objetDemande &&
        !!this.depotRequeteState.requeteCS.contexteInterventionDecision &&
        !!this.depotRequeteState.requeteCS.pourquoiSommeDue &&
        !!this.depotRequeteState.requeteCS.montantDuMontant &&
        !!this.depotRequeteState.requeteCS.conclusionReclamerSommeCondamnerAdmin;
    }

    updateReclamerUneSommeChampsObligatoireFilledObj(): void {
        if (this.depotRequeteState.requeteCS.typeLitige == null) {
            this.reclamerUneSommeChampsObligatoiresFilled.typeLitige = false;
            return;
        }
        if (this.depotRequeteState.requeteCS.nomsAdministrations == null) {
            this.reclamerUneSommeChampsObligatoiresFilled.nomsAdministrations = false;
        }
        if (this.depotRequeteState.requeteCS.objetDemande == null) {
            this.reclamerUneSommeChampsObligatoiresFilled.objetDemande = false;
        }
        if (this.depotRequeteState.requeteCS.contexteInterventionDecision == null) {
            this.reclamerUneSommeChampsObligatoiresFilled.contexteInterventionDecision = false;
        }
        if (this.depotRequeteState.requeteCS.pourquoiSommeDue == null) {
            this.reclamerUneSommeChampsObligatoiresFilled.pourquoiSommeDue = false;
        }
        if (this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.SOMME_DUE).length > 0) {
                this.depotRequeteState.piecesComplementaires.filter(pc =>
                    pc.complementaryFileOriginType === PieceComplementaireOrigineType.SOMME_DUE).forEach(sd => {
                        if (!sd.libelle || sd.libelle.trim() === '') {
                            this.reclamerUneSommeChampsObligatoiresFilled.pieceSommeDue = false;
                        }
                    })
        }
        if (this.depotRequeteState.requeteCS.montantDuMontant == null) {
            this.reclamerUneSommeChampsObligatoiresFilled.montantDuMontant = false;
        }
        if (this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.MONTANT_DU).length > 0) {
                this.depotRequeteState.piecesComplementaires.filter(pc =>
                    pc.complementaryFileOriginType === PieceComplementaireOrigineType.MONTANT_DU).forEach(md => {
                        if (!md.libelle || md.libelle.trim() === '') {
                            this.reclamerUneSommeChampsObligatoiresFilled.pieceMontantDu = false;
                        }
                    })
        }

        if (this.depotRequeteState.requeteCS.conclusionReclamerSommeCondamnerAdmin == null) {
            this.reclamerUneSommeChampsObligatoiresFilled.conclusionReclamerSommeCondamnerAdmin = false;
        }
    }


    checkReclamerUneSommePieceComplementaire(): boolean {
        let pieceComplementaireValid = true;
        const pieceSommeDue = this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.SOMME_DUE);
        pieceSommeDue.forEach(psd => {
            if (!psd.libelle || psd.libelle.trim() === '') {
                pieceComplementaireValid = false;
            }
        });

        const pieceMontantDu = this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.MONTANT_DU);
        pieceMontantDu.forEach(pmd => {
            if (!pmd.libelle || pmd.libelle.trim() === '') {
                pieceComplementaireValid = false;
            }
        })

        return pieceComplementaireValid;
    }

    checkContesterUneSomme(): boolean {
        this.updateContesterUneSommeChampsObligatoireFilledObj();
        const champsCommuns = !!this.depotRequeteState.acteAttaquesAFusioner[0] &&
        !!this.depotRequeteState.requeteCS.nomsAdministrations &&
        !!this.depotRequeteState.requeteCS.objetDemande &&
        !!this.depotRequeteState.requeteCS.faitConduitAuLitige &&
        !!this.depotRequeteState.requeteCS.typeActe;
        if (this.depotRequeteState.requeteCS.typeActe === 'Un avis d\'imposition') {
            return champsCommuns && this.checkAvisImposition();
        } else {
            return champsCommuns && this.checkAutreActe();
        }
    }

    checkAvisImposition(): boolean {
        const champsCommuns = !!this.depotRequeteState.requeteCS.raisonPasPayerImpot &&
        !!this.depotRequeteState.requeteCS.conclusionAvisImpositionImpot &&
        this.checkLibellePieceComplementaire(PieceComplementaireOrigineType.AVIS_IMPOSITION_INFONDEE_ET_AUTRE);
        return champsCommuns && this.checkRaisonAvisDimpositionIrregulier();
    }

    checkRaisonAvisDimpositionIrregulier(): boolean {
        // au moins un choix doit être coché
      let raisonAvisDimpositionIrregulierValid = true;
      if (!this.depotRequeteState.requeteCS.raisonAvisDimpositionIrreguliers) {
        raisonAvisDimpositionIrregulierValid = false;
      } else {
        if (this.depotRequeteState.requeteCS.raisonAvisDimpositionIrreguliers.length <= 0) {
            raisonAvisDimpositionIrregulierValid = false;
        }
      }
      return raisonAvisDimpositionIrregulierValid;

    }

    checkLibellePieceComplementaire(originType: PieceComplementaireOrigineType): boolean {
        let pieceComplementaireValid = true;
        const pcs = this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === originType);
        pcs.forEach(p => {
            if (!p.libelle || p.libelle.trim() === '') {
                pieceComplementaireValid = false;
            }
        })
        return pieceComplementaireValid;
    }

    checkAutreActe(): boolean {
        return this.checkRaisonInvalidationTitre() &&
        !!this.depotRequeteState.requeteCS.conclusionContesterSommeTitreEmisIrregulierDes &&
        !!this.depotRequeteState.requeteCS.conclusionContesterSommeTitreEmisIrregulierMontant;
    }

    checkRaisonInvalidationTitre(): boolean {
        // au moins un choix doit être coché
        // une fois coché, le détail doit être rempli
        let raisonInvalidationTitreValid = true;
        if (!this.depotRequeteState.requeteCS.raisonInvalidationTitres) {
            raisonInvalidationTitreValid = false;
        } else {
            if (this.depotRequeteState.requeteCS.raisonInvalidationTitres.length <= 0) {
                raisonInvalidationTitreValid = false;
            } else {
                this.depotRequeteState.requeteCS.raisonInvalidationTitres.forEach(rit => {
                    if (!rit.detail) {
                        raisonInvalidationTitreValid = false;
                    }
                });

            }
        }
        return raisonInvalidationTitreValid;
    }

    updateContesterUneSommeChampsObligatoireFilledObj(): void {
        if (this.depotRequeteState.requeteCS.nomsAdministrations == null) {
            this.contesterUneSommeChampsObligatoiresFilled.nomsAdministrations = false;
        }
        if (this.depotRequeteState.requeteCS.objetDemande == null) {
            this.contesterUneSommeChampsObligatoiresFilled.objetDemande = false;
        }
        if (this.depotRequeteState.requeteCS.faitConduitAuLitige == null) {
            this.contesterUneSommeChampsObligatoiresFilled.faitConduitAuLitige = false;
        }
        if (this.depotRequeteState.requeteCS.typeActe == null) {
            this.contesterUneSommeChampsObligatoiresFilled.typeActe = false;
        } else {
            this.contesterUneSommeChampsObligatoiresFilled.typeActe = true;
            if (this.depotRequeteState.requeteCS.typeActe === 'Un avis d\'imposition') {
                if (this.depotRequeteState.requeteCS.raisonAvisDimpositionIrreguliers == null ||
                    this.depotRequeteState.requeteCS.raisonAvisDimpositionIrreguliers === undefined ||
                    this.depotRequeteState.requeteCS.raisonAvisDimpositionIrreguliers.length === 0) {
                    this.contesterUneSommeChampsObligatoiresFilled.raisonAvisDimpositionIrreguliers = false;
                }
                if (this.depotRequeteState.requeteCS.conclusionAvisImpositionImpot == null) {
                    this.contesterUneSommeChampsObligatoiresFilled.conclusionAvisImpositionImpot = false;
                }
                if (this.depotRequeteState.requeteCS.raisonPasPayerImpot == null) {
                    this.contesterUneSommeChampsObligatoiresFilled.raisonPasPayerImpot = false;
                }
                if (this.depotRequeteState.piecesComplementaires
                    .filter(pc => pc.complementaryFileOriginType ===
                        PieceComplementaireOrigineType.AVIS_IMPOSITION_INFONDEE_ET_AUTRE).length > 0) {
                        this.depotRequeteState.piecesComplementaires.filter(pc =>
                            pc.complementaryFileOriginType === PieceComplementaireOrigineType.AVIS_IMPOSITION_INFONDEE_ET_AUTRE)
                            .forEach(aiec => {
                                if (!aiec.libelle || aiec.libelle.trim() === '') {
                                    this.contesterUneSommeChampsObligatoiresFilled.pieceAvisImpositionInfondeeEtAutreLibelle
                                    = false;
                                }
                            })
                }
            } else {
                if (this.depotRequeteState.requeteCS.raisonInvalidationTitres == null ||
                    this.depotRequeteState.requeteCS.raisonInvalidationTitres === undefined ||
                    this.depotRequeteState.requeteCS.raisonInvalidationTitres.length === 0) {
                    this.contesterUneSommeChampsObligatoiresFilled.raisonInvalidationTitres = false;
                }
                if (this.depotRequeteState.requeteCS.raisonInvalidationTitres != null &&
                    this.depotRequeteState.requeteCS.raisonInvalidationTitres.length > 0 &&
                    this.depotRequeteState.requeteCS.raisonInvalidationTitres.some(r => !r.detail)) {
                    this.contesterUneSommeChampsObligatoiresFilled.raisonInvalidationTitreDetail = false;
                }
                if (this.depotRequeteState.requeteCS.conclusionContesterSommeTitreEmisIrregulierDes == null) {
                    this.contesterUneSommeChampsObligatoiresFilled.conclusionContesterSommeTitreEmisIrregulierDes = false;
                }
                if (this.depotRequeteState.requeteCS.conclusionContesterSommeTitreEmisIrregulierMontant == null) {
                    this.contesterUneSommeChampsObligatoiresFilled.conclusionContesterSommeTitreEmisIrregulierMontant = false;
                }
            }
        }
    }

    checkReclamerUneIndemnisation(): boolean {
        this.updateIndemnisationChampsObligatoireFilledObj()
        return !!this.depotRequeteState.reclamationPrealablesAFusioner[0] &&
        !!this.depotRequeteState.requeteCS.nomsAdministrations &&
        !!this.depotRequeteState.requeteCS.objetDemande &&
        !!this.depotRequeteState.requeteCS.faitConduitSituationReparation &&
        this.checkPrejudiceEvaluableEnArgent() &&
        this.checkLibellePieceComplementaire(PieceComplementaireOrigineType.PRECISION_PREJUDICE) &&
        !!this.depotRequeteState.requeteCS.precisionPrejudice &&
        !!this.depotRequeteState.requeteCS.originePrejudice &&
        !!this.depotRequeteState.requeteCS.conclusionIndemnisationCondamnerAdmin &&
        !!this.depotRequeteState.requeteCS.conclusionIndemnisationMontant;
    }

    checkPrejudiceEvaluableEnArgent(): boolean {
      // au moins un choix doit être coché
      let prejudiceEvaluableEnArgentValid = true;
      if (!this.depotRequeteState.requeteCS.prejudiceEvaluableEnArgents) {
        prejudiceEvaluableEnArgentValid = false;
      } else {
        if (this.depotRequeteState.requeteCS.prejudiceEvaluableEnArgents.length <= 0) {
            prejudiceEvaluableEnArgentValid = false;
        }
      }
      return prejudiceEvaluableEnArgentValid;
    }

    updateIndemnisationChampsObligatoireFilledObj(): void {
        if (this.depotRequeteState.requeteCS.nomsAdministrations == null) {
            this.indemnisationChampsObligatoiresFilled.nomsAdministrations = false;
        }
        if (this.depotRequeteState.requeteCS.objetDemande == null) {
            this.indemnisationChampsObligatoiresFilled.objetDemande = false;
        }
        if (this.depotRequeteState.requeteCS.faitConduitSituationReparation == null) {
            this.indemnisationChampsObligatoiresFilled.faitConduitSituationReparation = false;
        }
        if (this.depotRequeteState.requeteCS.prejudiceEvaluableEnArgents == null ||
            this.depotRequeteState.requeteCS.prejudiceEvaluableEnArgents === undefined ||
            this.depotRequeteState.requeteCS.prejudiceEvaluableEnArgents.length === 0) {
            this.indemnisationChampsObligatoiresFilled.prejudiceEvaluableEnArgents = false;
        }
        if (this.depotRequeteState.requeteCS.precisionPrejudice == null) {
            this.indemnisationChampsObligatoiresFilled.precisionPrejudice = false;
        }
        if (this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.PRECISION_PREJUDICE).length > 0) {
                this.depotRequeteState.piecesComplementaires.filter(pc =>
                    pc.complementaryFileOriginType === PieceComplementaireOrigineType.PRECISION_PREJUDICE).forEach(pp => {
                        if (!pp.libelle || pp.libelle.trim() === '') {
                            this.indemnisationChampsObligatoiresFilled.piecePrecisionPrejudiceLibelle = false;
                        }
                    })
        }
        if (this.depotRequeteState.requeteCS.originePrejudice == null) {
            this.indemnisationChampsObligatoiresFilled.originePrejudice = false;
        }
        if (this.depotRequeteState.requeteCS.conclusionIndemnisationCondamnerAdmin == null) {
            this.indemnisationChampsObligatoiresFilled.conclusionIndemnisationCondamnerAdmin = false;
        }
        if (this.depotRequeteState.requeteCS.conclusionIndemnisationMontant == null) {
            this.indemnisationChampsObligatoiresFilled.conclusionIndemnisationMontant = false;
        }
    }


    updateRequeteRedigeePCFilledObj(): void {
        if (this.depotRequeteState.piecesComplementaires.filter(pc =>
            pc.complementaryFileOriginType === PieceComplementaireOrigineType.REQUETE_REDIGEE_JUSTIFICATIF).length > 0) {
                this.depotRequeteState.piecesComplementaires.filter(pc =>
                    pc.complementaryFileOriginType === PieceComplementaireOrigineType.REQUETE_REDIGEE_JUSTIFICATIF).forEach(rr => {
                        if (!rr.libelle || rr.libelle.trim() === '') {
                            this.requeteRedigeePieceComplementaireLebelleFilled.requeteRedigeePCLibelle = false;
                        }
                    })
        } else {
            this.requeteRedigeePieceComplementaireLebelleFilled.requeteRedigeePCLibelle = true;
        }

    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/requete/requete.component.ts